import React from 'react'
import { useTranslation } from 'react-i18next'

import { Share } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'

import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'
import analyticsService from '../../services/AnalyticsService'
import { AnalyticsProviders } from '../../types/IAnalyticsProvider'
import './ShareUrlButton.scss'

type ShareUrlButtonProps = ButtonProps & {
  trackingId?: string
  label?: string
}

const ShareUrlButton: React.FC<ShareUrlButtonProps> = ({ label, trackingId, ...buttonProps }) => {
  const { t } = useTranslation()
  const copyToClipboard = useCopyToClipboard()
  const buttonLabel = !label ? t('common:share_button_label') : label

  const copyUrlToClipboard = () => {
    copyToClipboard(window.location.href)

    if (trackingId) {
      analyticsService.trackEvent('Share Button', {
        data: { shareId: trackingId },
        serviceToExclude: [AnalyticsProviders.intercom, AnalyticsProviders.hubspot],
      })
    }
  }

  return (
    <Button {...buttonProps} variant="contained" color="primary" startIcon={<Share />} onClick={copyUrlToClipboard} className="ShareUrlButton">
      {buttonLabel}
    </Button>
  )
}

export default ShareUrlButton
